/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IInitializeHound,
  IInitializeHoundInterface,
} from "../IInitializeHound";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        internalType: "struct Hound.Struct",
        name: "createdHound",
        type: "tuple",
      },
    ],
    name: "initializeHound",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IInitializeHound__factory {
  static readonly abi = _abi;
  static createInterface(): IInitializeHoundInterface {
    return new utils.Interface(_abi) as IInitializeHoundInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IInitializeHound {
    return new Contract(address, _abi, signerOrProvider) as IInitializeHound;
  }
}
